import { render } from "./DetailedPage.vue?vue&type=template&id=600da8bc&scoped=true"
import script from "./DetailedPage.vue?vue&type=script&lang=js"
export * from "./DetailedPage.vue?vue&type=script&lang=js"

import "./DetailedPage.vue?vue&type=style&index=0&id=600da8bc&lang=scss&scoped=true"

import exportComponent from "/Users/benjamin_nalo/Ben/portfolio-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600da8bc"]])

export default __exports__